module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Preface-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter preface"
    }
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "id": "page-vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/toc#toc-preface002"
    }
  }, [_vm._v("PUBLISHER’S NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As stated by the author, “On many levels, Alzheimer’s research is an exciting grab bag of uncertain theories, despite a hard-core center of scientific belief. Certainty about cause and preventive interventions has not yet been engraved in stone.” So while this book includes preventive measures based on research by credentialed investigators, the information and advice contained in this book should not be interpreted as a definitive way to prevent Alzheimer’s but rather as a guide to suggested measures that may help prevent Alzheimer’s. This book is not intended to replace the services of a physician, nor does it constitute a doctor-patient relationship. Information in this book is provided for informational purposes only. You should consult your physician or health care professional regarding your care, in particular, with respect to any symptoms that may require diagnosis or medical attention. This book was current as of June 2010, and as new data become available through "), _c('a', {
    attrs: {
      "id": "page-viii"
    }
  }), _vm._v("research, experience, or changes to product contents, some of the information in this book may become outdated. Any action on your part in response to the information provided in this book is at your discretion. You should consult your physician or health care professional concerning any information contained in this book, and follow their professional advice. The publisher makes no representations or warranties pertaining to any information contained in this book and is not liable for any direct or indirect claim, loss, or damage resulting from the use of information contained in this book.")]), _vm._v(" "), _c('p', [_vm._v("Please note that the author is not active as an investor, owner, consultant, writer, or management participant in any nutritional supplement company or enterprise, and does not profit financially from the promotion or sale of any nutritional supplements.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8ea808","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface002.vue
// module id = 75
// module chunks = 0